
import * as React from 'react';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IActionProps, Action } from '../../action/Action';
import { withSelectedItems, withExactlyOneItem } from '../../decorators/selectors';
import { openUrlFacet } from '../../../facets/ItemFacets';
import { targetWindowControl } from '../../../controls/targetWindowControl';
import { getItemActionEngagement } from '../../../models/telemetry/getItemEngagement';

const doNothing = async () => { /* Nothing */ };

/**
 * @public
 */
export interface IItemOpenUrlActionProps {
    itemKey: string;
}

/**
 * @public
 */
export const ItemOpenUrlAction: React.ComponentType<IItemOpenUrlActionProps> = connectToItemCache((
    itemCache: IItemCache,
    props: IItemOpenUrlActionProps
): IActionProps => {
    const {
        itemKey
    } = props;

    const {
        openUrl,
    } = itemCache.demandItem({
        openUrl: openUrlFacet,
    }, itemKey);

    const targetWindowControlHandler = itemCache.demandItemFacet(targetWindowControl, undefined);

    const {
        targetWindow
    } = targetWindowControl.evaluate(targetWindowControlHandler)(itemCache, {});

    return {
        isAvailable: !!openUrl,
        onExecute: openUrl ? async () => {
            if (targetWindow) {
                targetWindow.location.href = openUrl;
            } else {
                window.open(openUrl);
            }
        } : doNothing,
        ...getItemActionEngagement(itemCache, {
            itemKey,
            engagement: {
                name: 'OpenUrl',
                isIntentional: true
            }
        })
    };
})(Action);

/**
 * @public
 */
export const OpenUrlAction: React.ComponentType<{}> = withSelectedItems()(withExactlyOneItem()(ItemOpenUrlAction));
